const SOURCE_NOT_SELECTED = 'Please select "Event Source"';

export const eventSourceValidation = (eventSource: string): string[] => {
    const errorMassages = [];

    if (!eventSource) {
        errorMassages.push(SOURCE_NOT_SELECTED);
    }

    return errorMassages;
};
